/* DYO theme — sliding cart drawer, Ajax Cart API + Section Rendering API.
   The drawer's markup lives in sections/cart-drawer.liquid so all line-item
   templating stays in Liquid; this file only triggers refetches and wires
   up the interactive bits (qty steppers, quick-add, checkout gate). */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  var backdrop = document.querySelector('[data-cart-backdrop]');
  if (!drawer || !backdrop) return;

  var lastFocused = null;

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = '— ' + count;
    });
  }

  function setLoading(isLoading) {
    drawer.setAttribute('data-loading', isLoading ? 'true' : 'false');
  }

  function loadRecommendations() {
    var holder = drawer.querySelector('[data-cart-recommendations]');
    if (!holder) return;
    var productId = holder.getAttribute('data-product-id');
    if (!productId || !window.themeRoutes) return;
    var url = window.themeRoutes.productRecommendations +
      '?section_id=cart-drawer-recommendations&product_id=' + encodeURIComponent(productId) +
      '&limit=6&intent=related';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) { holder.innerHTML = html; })
      .catch(function () {});
  }

  function refreshDrawer() {
    setLoading(true);
    var sep = window.location.search ? '&' : '?';
    return fetch(window.location.pathname + window.location.search + sep + 'sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var wrap = document.getElementById('shopify-section-cart-drawer');
        if (wrap && data['cart-drawer']) wrap.outerHTML = data['cart-drawer'];
        loadRecommendations();
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {})
      .finally(function () { setLoading(false); });
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    // Open immediately with a loading spinner rather than waiting on the
    // fetch first — otherwise clicking the icon looks like it did nothing
    // for however long the request takes.
    drawer.setAttribute('data-open', 'true');
    backdrop.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    refreshDrawer();
  }

  function closeDrawer() {
    drawer.setAttribute('data-open', 'false');
    backdrop.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(refreshDrawer);
  }

  document.querySelectorAll('[data-cart-toggle]').forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });

  backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') closeDrawer();
  });

  document.addEventListener('click', function (e) {
    if (!drawer.contains(e.target)) return;

    var closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var qtyBtn = e.target.closest('[data-qty]');
    if (qtyBtn) {
      var wrap = qtyBtn.closest('[data-qty-ajax]');
      if (!wrap) return;
      var input = wrap.querySelector('[data-qty-input]');
      var key = wrap.getAttribute('data-line-key');
      var v = parseInt(input.value, 10) || 0;
      v = qtyBtn.getAttribute('data-qty') === 'up' ? v + 1 : Math.max(0, v - 1);
      changeLine(key, v);
      return;
    }

    var checkoutBtn = e.target.closest('[data-cart-checkout]');
    if (checkoutBtn && !checkoutBtn.disabled && window.themeRoutes) {
      window.location.href = window.themeRoutes.cartCheckout;
      return;
    }

    var quickAdd = e.target.closest('[data-quick-add]');
    if (quickAdd) {
      quickAdd.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: quickAdd.getAttribute('data-variant-id'), quantity: 1 })
      })
        .then(refreshDrawer)
        .finally(function () { quickAdd.disabled = false; });
      return;
    }

    var recBtn = e.target.closest('[data-recs-scroll]');
    if (recBtn) {
      var track = drawer.querySelector('.cart-drawer__recs-track');
      if (track) {
        track.scrollBy({ left: recBtn.getAttribute('data-recs-scroll') === 'left' ? -160 : 160, behavior: 'smooth' });
      }
    }
  });

  document.addEventListener('change', function (e) {
    if (!drawer.contains(e.target)) return;

    var qtyInput = e.target.closest('[data-qty-input]');
    if (qtyInput) {
      var wrap = qtyInput.closest('[data-qty-ajax]');
      var key = wrap.getAttribute('data-line-key');
      var v = Math.max(0, parseInt(qtyInput.value, 10) || 0);
      changeLine(key, v);
      return;
    }

    var terms = e.target.closest('[data-cart-terms]');
    if (terms) {
      var checkoutBtn = drawer.querySelector('[data-cart-checkout]');
      if (checkoutBtn) checkoutBtn.disabled = !terms.checked;
    }
  });
})();
